var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:_vm.containerClass,style:(_vm.containerStyle),attrs:{"role":"cell","data-p-editable-column":false,"data-p-frozen-column":_vm.frozen}})}
var staticRenderFns = []

export { render, staticRenderFns }